import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-card rounded-lg shadow-2xl border border-border overflow-hidden"
}
const _hoisted_2 = { class: "px-6 py-4" }
const _hoisted_3 = { class: "px-6 py-4 border-t border-border flex items-center justify-end gap-3" }

interface Props {
  isOpen: boolean
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  isDangerous?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    isOpen: { type: Boolean },
    title: { default: '' },
    message: {},
    confirmText: { default: 'Confirm' },
    cancelText: { default: 'Cancel' },
    isDangerous: { type: Boolean, default: false }
  },
  emits: ["confirm", "cancel", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleConfirm = () => {
  emit('confirm');
};

const handleCancel = () => {
  emit('cancel');
};

const handleBackdropClick = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-gray-800/50 z-50 flex items-center justify-center p-4",
              onClick: handleBackdropClick
            }, [
              _createElementVNode("div", {
                class: "w-full max-w-sm",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_Transition, { name: "scale-up" }, {
                  default: _withCtx(() => [
                    (__props.isOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          (__props.title)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([
                     'px-6 py-4 border-b border-border ',
                     __props.isDangerous ? 'bg-red-50' : 'bg-gray-600',
                   ])
                              }, [
                                _createElementVNode("h2", {
                                  class: _normalizeClass(['text-lg font-bold', __props.isDangerous ? 'text-red-700' : 'text-foreground'])
                                }, _toDisplayString(__props.title), 3)
                              ], 2))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("p", {
                              class: _normalizeClass(['text-foreground', __props.isDangerous ? 'text-red-600' : ''])
                            }, _toDisplayString(__props.message), 3)
                          ]),
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("button", {
                              class: "btn-outline rounded-lg px-4 py-2 font-semibold text-foreground",
                              onClick: handleCancel
                            }, _toDisplayString(__props.cancelText), 1),
                            _createElementVNode("button", {
                              class: _normalizeClass([
                          'rounded-lg px-4 py-2 font-semibold text-white',
                          __props.isDangerous
                            ? 'bg-red-600 hover:bg-red-700'
                            : 'bg-primary hover:bg-primary/90',
                        ]),
                              onClick: handleConfirm
                            }, _toDisplayString(__props.confirmText), 3)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})